import React, {useState} from 'react';
import './image-info.css'

const ImageInfo = ({isImageOnTheLeft=true, title="Add Title", text="Add Text", image="" })=> {

    return (
        <div className="image-info-wrapper">
            <div className="row">
                {isImageOnTheLeft ? 
                    <div className="info-picture-wrapper center col-sm-12 col-md-6">
                        <img className="info-picture popout-slow" src={image} alt="headshot" />
                    </div> : ""
                }

                <div className="image-info-detail center col-sm-12 col-md-6">
                    <h3>{title}</h3>
                    <p>
                        {text}    
                    </p>
                </div>

                {!isImageOnTheLeft ? 
                    <div className="info-picture-wrapper center col-sm-12 col-md-6">
                        <img className="info-picture popout-slow" src={image} alt="headshot" />
                    </div> : ""
                }
            </div>
        </div>
    )
}

export default ImageInfo;
